export const ORCHESTRATION_SERVICE_ENDPOINT = {
    VALIDATE_PRODUCT_TENANT: '/validateProductTenant',
  };
  